module.exports = __webpack_public_path__ + "img/v2x.3b8e37b8.png";